import { useEffect, useState } from 'react';
import ReportCard from './components/ReportCard';
import ReportAccordion from './components/ReportAccordion';
import { getReportsByUser } from '../../../api/reports.api';
import AdminManualReportModal from '../../../components/AdminManualReportModal';

export default function ReportsTab({ userId }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  // ۲. استیت برای نمایش مودال
  const [showManualModal, setShowManualModal] = useState(false);

  useEffect(() => {
    loadReports();
  }, [userId]);

  const loadReports = async () => {
    setLoading(true);
    try {
      const res = await getReportsByUser(userId);
      let list = res.data.reports || [];
      // مرتب‌سازی بر اساس تاریخ (نزولی)
      list = list.sort(
        (a, b) =>
          new Date(b.date || b.createdAt) - new Date(a.date || a.createdAt),
      );
      setReports(list);
    } catch (err) {
      console.error('Error loading reports', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p className="text-center p-10">در حال بارگذاری...</p>;

  const latestReport = reports[0];
  const oldReports = reports.slice(1);

  return (
    <div className="space-y-6">
      {/* ۳. دکمه ثبت گزارش دستی در بالای صفحه */}
      <div className="flex justify-between items-center bg-blue-50 p-4 rounded-2xl border border-blue-100 shadow-sm">
        <div>
          <h3 className="font-bold text-blue-800">مدیریت گزارش‌های خارجی</h3>
          <p className="text-[11px] text-blue-600 mt-1">
            گزارش‌های دریافت شده از تلگرام یا واتس‌اپ را دستی وارد کنید.
          </p>
        </div>
        <button
          onClick={() => setShowManualModal(true)}
          className="bg-blue-600 text-white px-5 py-2 rounded-xl text-sm font-bold shadow-lg shadow-blue-200 hover:bg-blue-700 transition">
          + ثبت گزارش تلگرامی
        </button>
      </div>

      {reports.length === 0 ? (
        <p className="text-center py-10 text-gray-400 border-2 border-dashed rounded-2xl italic">
          هیچ گزارشی یافت نشد.
        </p>
      ) : (
        <>
          <div>
            <h3 className="text-lg font-bold mb-3 text-gray-700">
              آخرین گزارش
            </h3>
            <ReportCard
              report={latestReport}
              onFeedbackSubmitted={loadReports}
            />
          </div>

          {oldReports.length > 0 && (
            <div>
              <h3 className="text-lg font-bold mt-8 mb-3 text-gray-700">
                سوابق قبلی
              </h3>
              <div className="space-y-3">
                {oldReports.map((rep) => (
                  <ReportAccordion key={rep._id} report={rep} />
                ))}
              </div>
            </div>
          )}
        </>
      )}

      {/* ۴. نمایش مودال در صورت فعال بودن */}
      {showManualModal && (
        <AdminManualReportModal
          userId={userId}
          onClose={() => setShowManualModal(false)}
          onSuccess={loadReports}
        />
      )}
    </div>
  );
}
